import React, { useEffect } from 'react';
import { ReactComponent as Euro } from '../../assets/euro.svg';
import { Page } from '../../components/ui/Page'
import Store from '../../store/Store';
import { Body } from '../../components/layout/Body';

const Icon = ({
	IconComponent,
	className = '',
}: {
	IconComponent: React.ComponentType<{ className?: string }>;
	className?: string;
}) => <IconComponent className={`w-10 h-10 text-black opacity-50 ${className}`} />;

export interface MonetaryDashboardProps {
	id?: string;
}

interface OrderItem {
	orderId: string;
	name: string;
	orderState: string;
	dateFrom: string;
	price: number;
}

export default function MonetaryDashboard(props: MonetaryDashboardProps) {
	const [, orders] = Store.use('ordersError', 'orders') as [unknown, OrderItem[]];

	useEffect(() => {
		if (!orders?.length) Store.loadOrders();
	}, []);

	const orderList = Array.isArray(orders) ? orders : [];
	const completedOrdersTotal = orderList
		.filter((order) => order.orderState === 'COMPLETED')
		.reduce((sum, order) => sum + order.price, 0);

	const restOrdersTotal = orderList
		.filter((order) => order.orderState !== 'COMPLETED')
		.reduce((sum, order) => sum + order.price, 0);

	return (
		<Page>
			<Body id={props.id}>
				<div className="w-full flex flex-col gap-4">
					<div className="w-full h-[110px] flex flex-row justify-between gap-4">
						<div className="bg-[#FAB64F] border rounded-xl p-4 flex flex-col grow">
							<div className="grow">Ausständig</div>
							<div className="flex flex-row grow text-4xl content-between">
								<div className="grow">€ {restOrdersTotal.toFixed(2)}</div>
								<div className="w-10 h-10">
									<Icon IconComponent={Euro} />
								</div>
							</div>
						</div>
						<div className="bg-[#81C1CE] border rounded-xl p-4 flex flex-col grow">
							<div className="grow">Offen zur Auszahlung</div>
							<div className="flex flex-row grow text-4xl content-between">
								<div className="grow">
									€ {(completedOrdersTotal * 0.15).toFixed(2)}
								</div>
								<div className="w-10 h-10">
									<Icon IconComponent={Euro} />
								</div>
							</div>
						</div>
						<div className="bg-[#BBCF00] border rounded-xl p-4 flex flex-col grow">
							<div className="grow">Ausgezahlt</div>
							<div className="flex flex-row grow text-4xl content-between">
								<div className="grow">
									€ {(completedOrdersTotal * 0.85).toFixed(2)}
								</div>
								<div className="w-10 h-10">
									<Icon IconComponent={Euro} />
								</div>
							</div>
						</div>
					</div>
				</div>
				<h2>Bestellung im Detail</h2>
				<div className="w-full h-[400px] flex flex-col">
					<div className="flex-1 h-full w-full">
						<div className="grid grid-cols-6 gap-4 border-b-2">
							<div>ID</div>
							<div>Name</div>
							<div>Datum</div>
							<div>Preis</div>
							<div>Status</div>
							<div>Abrechnung</div>
						</div>
						<div>
							{orderList
								.filter((order) => order.orderState !== 'AWAITING_PAYMENT')
								.map((o, i) => (
									<div
										key={o.orderId}
										className="grid grid-cols-6 gap-4 mt-2"
									>
										<div>{i + 1}</div>
										<div>{o.name}</div>
										<div>{o.dateFrom}</div>
										<div>€ {o.price}</div>
										<div>{o.orderState}</div>
										<div>
											{o.orderState === 'COMPLETED' ? 'Ausbezahlt' : 'Offen'}
										</div>
									</div>
								))}
						</div>
					</div>
				</div>
			</Body>
		</Page>
	);
}
